import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1086Status: 'idle',
    startProcess1086Error: undefined as any,
    loadUserParamsProcess1086Status: 'idle',
    loadUserParamsProcess1086Error: undefined as any,

    process1086List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1086 = createAsyncThunk('process1086Slice/startProcess1086', async ({ process1086 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1086/`,
        prepareData(process1086),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1086Status } = getState().process1086Slice
        return startProcess1086Status !== 'pending'
    }
})

export const loadUserParamsProcess1086 = createAsyncThunk('process1086Slice/loadUserParamsProcess1086', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1086/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1086Status } = getState().process1086Slice
        return loadUserParamsProcess1086Status !== 'pending'
    }
})

const Process1086Slice = createSlice({
    name: 'process1086Slice',
    initialState,
    reducers: {
        resetstartProcess1086: (state) => {
            state.job = undefined
            state.startProcess1086Error = undefined
        },
        resetstartProcess1086Error: (state) => {
            state.startProcess1086Error = undefined
        },
        resetloadUserParamsProcess1086: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1086Error = undefined
        },
        resetloadUserParamsProcess1086Error: (state) => {
            state.loadUserParamsProcess1086Error = undefined
        },
        removeFromProcess1086ListById: (state, action) => {
            state.process1086List = state.process1086List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1086ListByIds: (state, action) => {
            state.process1086List = state.process1086List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1086List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1086Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1086List = []
            state.startProcess1086Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1086.pending, (state) => {
            state.startProcess1086Status = 'pending'
            state.startProcess1086Error = undefined
        })
        builder.addCase(startProcess1086.fulfilled, (state, action) => {
            state.startProcess1086Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1086.rejected, (state, action) => {
            state.startProcess1086Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1086Error = action.error.message
            } else {
                state.startProcess1086Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1086.pending, (state) => {
            state.loadUserParamsProcess1086Status = 'pending'
            state.loadUserParamsProcess1086Error = undefined
        })
        builder.addCase(loadUserParamsProcess1086.fulfilled, (state, action) => {
            state.loadUserParamsProcess1086Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1086.rejected, (state, action) => {
            state.loadUserParamsProcess1086Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1086Error = action.error.message
            } else {
                state.loadUserParamsProcess1086Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1086,
    resetstartProcess1086Error,
    resetloadUserParamsProcess1086,
    resetloadUserParamsProcess1086Error,
    removeFromProcess1086ListById,
    removeFromProcess1086ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1086Slice.actions
export default Process1086Slice.reducer
